import { BatteryChargingWirelessOutlineIcon } from './BatteryChargingWirelessOutlineIcon';

/**
 * author: Michael Richins
 * id 4AFDE54E-1A6D-4F7F-BD0D-AB67FB0F12CC
 * name battery-charging-wireless-outline
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/battery-charging-wireless-outline.svg
 * tags
 * - Battery 
 * - Home Automation 
 */
export const BatteryChargingWirelessEmptyIcon = BatteryChargingWirelessOutlineIcon;
export default BatteryChargingWirelessEmptyIcon